module.exports = __webpack_public_path__ + "img/store.c8e99d27.svg";